"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_html_parser_1 = __importDefault(require("react-html-parser"));
const components_1 = require("components");
const cil_check_circle_svg_1 = __importDefault(require("images/utility-icons/cil-check-circle.svg"));
const cil_paperclip_svg_1 = __importDefault(require("images/utility-icons/cil-paperclip.svg"));
const cil_report_svg_1 = __importDefault(require("images/utility-icons/cil-report.svg"));
const cil_warning_svg_1 = __importDefault(require("images/utility-icons/cil-warning.svg"));
const tooltip_icon_svg_1 = __importDefault(require("images/utility-icons/tooltip-icon.svg"));
function NotificationsBanner({ notifications }) {
    const [dismissedIds, setDismissedIds] = (0, react_1.useState)(() => {
        try {
            return JSON.parse(sessionStorage.getItem('notificationsDismissed') || '[]');
        }
        catch {
            return [];
        }
    });
    const [notificationsArray, setNotifications] = (0, react_1.useState)([]);
    const clearNotification = (0, react_1.useCallback)((notificationToRemove) => {
        const updated = [...dismissedIds, notificationToRemove.id];
        sessionStorage.setItem('notificationsDismissed', JSON.stringify(updated));
        setDismissedIds(updated);
    }, [dismissedIds]);
    const getIcon = (level) => {
        switch (level) {
            case 'success':
                return cil_check_circle_svg_1.default;
            case 'note':
                return cil_paperclip_svg_1.default;
            case 'warn':
            case 'warning':
                return cil_warning_svg_1.default;
            case 'danger':
                return cil_report_svg_1.default;
            default:
                return tooltip_icon_svg_1.default;
        }
    };
    (0, react_1.useEffect)(() => {
        setNotifications(notifications.filter((n) => !dismissedIds.includes(n.id)));
    }, [notifications, dismissedIds]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "notifications-banner-section", children: notificationsArray.map((notification, idx) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: `notification-banner odd flex space-between align-center level-${notification.level ?? 'default'}`, children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex align-start", children: [(0, jsx_runtime_1.jsx)("img", { src: getIcon(notification.level), alt: "information", className: "tooltip-icon" }), (0, react_html_parser_1.default)(notification.content)] }), (0, jsx_runtime_1.jsx)(components_1.ButtonLink, { style: { paddingLeft: '1.5%' }, onClick: () => clearNotification(notification), className: "link-secondary", children: "Dismiss" })] }) }, `notification-item-${idx}`))) }));
}
exports.default = NotificationsBanner;
